import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateViolationsConfiguration } from './updateViolationsConfiguration'
import { ViolationConfigurationPayload } from './types'

import { QUERY_KEY_SETTINGS_VIOLATION } from '@/lib/api/constants'
import { toast } from '@/lib/toasts/api'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

export function useMutationViolationsConfiguration(companyId: string) {
  const queryClient = useQueryClient()
  const { t } = useLocalize()

  return useMutation({
    mutationFn: async (payload: ViolationConfigurationPayload) => {
    //   if (COMPANY_API_SETTINGS_MOCKED) {
    //     return { success: true, data: { message: 'Success' } }
    //   }
      const { data } = await updateViolationsConfiguration({
        companyId,
        payload,
      })
      return data
    },

    onError: (error) => {
      console.error('Error useMutationViolationsConfiguration:', error)
      toast.error({
        text: t('configuration.save-error'),
      })
    },

    onSuccess: (_responseData, payload) => {
      queryClient.setQueryData([QUERY_KEY_SETTINGS_VIOLATION, companyId], payload)
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_VIOLATION, companyId] })
      toast.success({
        text: t('configuration.save-success'),
      })
    },
  })
}
